import { withStyles } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

const styles = (theme) => ({
  errorContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 0px'
  },
  message: {
    color: theme.violationColor,
    fontSize: theme.textFontSize
  },
  warningIcon: {
    color: theme.violationColor,
    marginRight: 4,
    fontSize: theme.headerTextFontSize16
  }
});

const DispatchError = ({ message, classes }) => {
  return (
    <div className={classes.errorContainer}>
      <InfoIcon className={classes.warningIcon} />
      <div className={classes.message}>{message}</div>
    </div>
  );
};

export default withStyles(styles)(DispatchError);
